angular.module('dnecom')
    .controller('EmailTemplatesController', ["$scope", "wizardModal", "$http", "$timeout", "notifications", "$location", "DTOptionsBuilder", "DTColumnDefBuilder", function EmailTemplatesController($scope, wizardModal, $http, $timeout, notifications, $location, DTOptionsBuilder, DTColumnDefBuilder) {
        $scope.currentStore = TemplateData.value('store');
        $scope.templates = TemplateData.value('templates');

        $scope.loading = false;

        $scope.getTemplates = function() {
            $scope.loading = true;

            $http
                .get(Routing.generate('notifications_get', {
                    store: $scope.currentStore.id
                }))
                .success(function(response) {
                    if (!response.hasOwnProperty('templates')) {
                        notifications.danger(response.message);
                        return;
                    }

                    $scope.templates = response.templates;
                })
                .finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                });
        };

        $scope.editTemplate = function(template) {
            $scope.prepareWizardModal(angular.copy(template), angular.copy($scope.templates));
        };

        $scope.revertTemplate = function(template) {
            $http
                .post(Routing.generate('notifications_delete', {
                    id: $scope.currentStore.id,
                    templateId: template.id
                }))
                .success(function(response) {
                    if (!response.success) {
                        alert(response.error || 'Failed to revert template.');
                        return;
                    }

                    $scope.getTemplates();
                })
                .error(function() {
                    alert('Failed to revert template.');
                });
        };

        $scope.prepareWizardModal = function(template) {
            var modal = wizardModal.open({
                templateUrl: 'emailTemplateWizardModal.html',
                controller: 'emailTemplateWizardModalController',
                resolve: {
                    template: function() {
                        return template;
                    }
                }
            });

            modal.result.then($scope.getTemplates);
        };

        $scope.sendTestMsg = function(template) {
            template.isTesting = true;

            $http
                .post(Routing.generate('notifications_test', {storeId: $scope.currentStore.id}), {
                    type: template.type
                })
                .then(
                    function(response) {
                        if (!response.data.success) {
                            notifications.danger('Error while trying to send test message');
                            return;
                        }
                        notifications.success("Test email has been sent to " + response.data.sentTo);
                    },
                    function() {
                        notifications.danger('Request error');
                    }
                )
                .finally(function() {
                    template.isTesting = false;
                });
        };
    }]);
